;(function() {
  'use strict'

  angular.module('core.surveyAnalyze', [])
})()
